import { render, staticRenderFns } from "./division.vue?vue&type=template&id=5f91f706&scoped=true&"
import script from "./division.vue?vue&type=script&lang=js&"
export * from "./division.vue?vue&type=script&lang=js&"
import style0 from "./division.vue?vue&type=style&index=0&id=5f91f706&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f91f706",
  null
  
)

export default component.exports